import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(AdvancedFormat);
dayjs.extend(LocalizedFormat);

export function formatDate(date) {
    return dayjs(date).format('Do MMMM YYYY');
}

export function formatDateTime(dateTime) {
    return dayjs(dateTime).format('Do MMMM YYYY @ HH:mm:ss');
}

export function formatTimeDate(dateTime) {
    return dayjs(dateTime).format('HH:mm Do MMMM YYYY');
}

export function formatLocalTime(dateTime) {
    return dayjs(dateTime).format('LT');
}
